import { type Draft, type PayloadAction } from '@reduxjs/toolkit';
import { type TCustomTheme, type TSettingsState } from '../settingsSlice';

/**
 * Don't use directly, instead use `themeTypeAction` from the corresponding slice/reduce file
 */
export const setCustomTheme = (state: Draft<TSettingsState>, action: PayloadAction<Partial<TCustomTheme>>) => {
  state.customTheme = { ...state.customTheme, ...action.payload };
};
